import React from 'react'

export function renderEquipment(ctx) {
  const {
    activeTab,
    equipmentForm,
    equipmentStatus,
    handleEquipmentDelete,
    handleEquipmentSubmit,
    previewUrls,
    setEquipmentForm,
    t,
    uploadedItems,
  } = ctx
  return (
    <>
          {activeTab === 'equipment' && (
            <div className="dash-section">
              <div className="dash-section-header"><h2>{t.equipmentManagement}</h2><p>{t.addManageEquipment}</p></div>
              <div className="dash-form-card">
                <h3>{t.addNewEquipment}</h3>
                <form className="dash-form" onSubmit={handleEquipmentSubmit}>
                  <div className="dash-form-row">
                    <label>{t.title} <span className="dash-required">*</span><input type="text" value={equipmentForm.title} onChange={e => setEquipmentForm(p => ({ ...p, title: e.target.value }))} placeholder="Cloud Server Bundle" /></label>
                    <label>{t.price} <span className="dash-required">*</span><input type="text" value={equipmentForm.price} onChange={e => setEquipmentForm(p => ({ ...p, price: e.target.value }))} placeholder="$2,500" /></label>
                  </div>
                  <label>{t.description} <span className="dash-required">*</span><textarea rows="3" value={equipmentForm.details} onChange={e => setEquipmentForm(p => ({ ...p, details: e.target.value }))} placeholder="High-performance compute..." /></label>
                  <label>Product Images (up to 5)<input type="file" accept="image/*" multiple onChange={e => setEquipmentForm(p => ({ ...p, images: Array.from(e.target.files || []).slice(0, 5) }))} /></label>
                  {previewUrls.length > 0 && <div className="dash-image-previews">{previewUrls.map((url, i) => <img key={i} src={url} alt={`Preview ${i + 1}`} className="dash-image-preview" />)}</div>}
                  <div className="dash-form-actions">
                    <button className="dash-btn primary" type="submit">{t.addEquipment}</button>
                    {equipmentStatus && <span className="dash-status-msg">{equipmentStatus}</span>}
                  </div>
                </form>
              </div>
              {uploadedItems.length === 0 ? <div className="dash-empty-state"><span>📦</span><p>{t.noEquipment}</p></div> : (
                <div className="dash-equipment-grid">
                  {uploadedItems.map(item => (
                    <div key={item.slug} className="dash-equipment-card">
                      {item.images[0] && <img src={item.images[0]} alt={item.name} className="dash-equipment-img" />}
                      <div className="dash-equipment-info">
                        <h4>{item.name}</h4><p className="dash-equipment-price">{item.price}</p>
                        <p className="dash-equipment-desc">{item.description}</p>
                        <button className="dash-delete-btn" onClick={() => handleEquipmentDelete(item.slug)}>Delete</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
    </>
  )
}
